import { httpRequest, http, request } from '@/utils/request';
import { CommonResponse } from '@/types';

export function getDeviceStatusTemplate() {
  return httpRequest<any, CommonResponse<string[]>>({
    url: '/api/v1/device/status-template',
  });
}

export interface IDeviceDetail {
  id: string;
  cloud_device_id: string;
  cloud_product_id: string;
  cloud_instance_id: string;
  name: string;
  status: string;
  description: string;
  product_id: string;
  product_name: string;
  secret: string;
  platform: string;
  device_service_name: string;
  last_sync_time: number;
  last_online_time: number;
  create_at: number;
  is_ipc?: boolean;
  device_sn: string;
  model: string;
  addr: string;
  device_type: string;
  child_device_count: number;
  ip: string;
  port: string;
  location: string;
  manufacturer: string;
  modified_at: number;
  slaveId: string;
  period: string;
  firmware: string;
  manufacture_no: string;
  device_address: string;
  enterprise_id: string;
  user_id: string;
}

export function getDeviceDetail(id: string) {
  return httpRequest<any, CommonResponse<IDeviceDetail>>({
    url: `/api/v1/device/${id}`,
  });
}

export function getDeviceDetailData({ id }: { id: string }) {
  return httpRequest<any, CommonResponse<IDeviceDetail>>({
    url: `/api/v1/device/${id}`,
  });
}

export function addDevice(data: { name: string; product_id: string; driver_instance_id: string; description?: string; image: string; lon: string; lat: string; device_sn?: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device',
    method: 'post',
    data,
  });
}

export function editDevices(data: { name: string; id: string; description: string; image: string; lon: string; lat: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/device/${data.id}`,
    method: 'put',
    data,
  });
}

export function deleteDevice(id: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/device/${id}`,
    method: 'delete',
  });
}

export function deviceSync(data: { cloud_instance_id: string; driver_instance_id: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device-sync',
    method: 'post',
    data,
  });
}

export function deviceSyncSingle(data: { device_id: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/device-sync/${data.device_id}`,
    method: 'post',
    data,
  });
}

export function uploadValidated(data: FormData) {
  return http({
    url: '/api/v1/device/upload-validated',
    method: 'post',
    data,
  });
}

export async function getDeviceMaps(params: { status?: string; name?: string }) {
  return request<CommonResponse<{ lat: string; lon: string; name: string; status: string }[]>>(`/api/v1/device/maps`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
  });
}
